export default __webpack_public_path__ + "static/media/1_14.baab5c70.png";